import React, { useCallback } from 'react';
import Tooltip from '@ingka/tooltip';
import Button from '@ingka/button';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectSearchPanelOpenForTree,
  toggleSearchPanel,
} from '../../store/slices/treeSearch';
import magnifyingGlassList from '@ingka/ssr-icon/paths/magnifying-glass-list';

import type { AppThunkDispatch, RootState } from '../../store';

const SearchToggler = function SearchToggler({ tree }: { tree: string }) {
  const dispatch = useDispatch<AppThunkDispatch>();
  const open = useSelector((state: RootState) =>
    selectSearchPanelOpenForTree(state, tree),
  );
  const toggleSearchAction = useCallback(
    () => dispatch(toggleSearchPanel(tree, !open)),
    [dispatch, tree, open],
  );

  return (
    <Tooltip
      describedById="search-pane-tooltip"
      interactiveCustomTrigger
      position="bottom"
      tooltipText={open ? 'Close search pane' : 'Open search pane'}
    >
      <Button
        type="tertiary"
        size="small"
        iconOnly
        aria-label={open ? 'Close search pane' : 'Open search pane'}
        onClick={toggleSearchAction}
        ssrIcon={magnifyingGlassList}
      />
    </Tooltip>
  );
};

export default SearchToggler;
